export default __webpack_public_path__ + "images/7e79a85bf3d2abf1de1332ce4c2ecc59-nonprofitandngos.jpg";